module.exports = __webpack_public_path__ + "img/qrcode-app.88097e7d.svg";